import React, { Component } from 'react';
export default class Header extends Component {
    render() {
        let resumeData = this.props.resumeData;
        return (<React.Fragment>{
            <footer>
                <div className = "row">
                    <div className = "twelve columns">
                        <ul className = "social-links">
                            <li> <a href = {resumeData.facebook_link}> <i className = "fa fa-facebook"/> </a>
                            </li>
                            {
                                /*
                                <li> <a href="#"> <i className="fa fa-twitter"/> </a>
                                </li>
                                <li> <a href="#"> <i className="fa fa-google-plus"/> </a>
                                </li>
                                */
                            }
                            <li> <a href = {resumeData.instagram_link}> <i className = "fa fa-instagram"/> </a>
                            </li>
                            <li> <a href = {resumeData.linkedin_link}> <i className = "fa fa-linkedin"/> </a>
                            </li>
                            {
                                /*
                                <li> <a href="#"> <i className="fa fa-dribbble"/> </a>
                                </li>
                                <li> <a href="#"> <i className="fa fa-skype"/> </a>
                                </li>
                                */
                            }
                            <li> <a href = {resumeData.github_repo}> <i className = "fa fa-github"/> </a>
                            </li>
                            <li> <a href = {resumeData.email_link}> <i className = "fa fa-envelope"/> </a>
                            </li>
                        </ul>
                        <ul className = "copyright">
                            <li > ©{resumeData.name} </li>
                        </ul>
                    </div>
                    <div id = "go-top">
                        <a className = "smoothscroll" title = "Back to Top" href = "#home"> <i className = "icon-up-open" / >
                        </a>
                    </div>
                </div>
            </footer>}
        </React.Fragment>);
    }
}